import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class RealmHeaderAppender implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let headers: HttpHeaders = req.headers;
    headers = headers.set('X-Synapse-Client', 'MANAGER');
    return next.handle(
      req.clone({
        headers,
        url: req.url,
      })
    );
  }
}
